import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=fdf5bee8"
import script from "./RoleManage.vue?vue&type=script&lang=js"
export * from "./RoleManage.vue?vue&type=script&lang=js"
import style0 from "./RoleManage.vue?vue&type=style&index=0&id=fdf5bee8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports